/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Emailaddress2Inputs */

const zh_organizationsettings_emailaddress2 = /** @type {(inputs: Organizationsettings_Emailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱地址`)
};

const en_organizationsettings_emailaddress2 = /** @type {(inputs: Organizationsettings_Emailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Address`)
};

const es_organizationsettings_emailaddress2 = /** @type {(inputs: Organizationsettings_Emailaddress2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico`)
};

/**
* | output |
* | --- |
* | "Email Address" |
*
* @param {Organizationsettings_Emailaddress2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_emailaddress2 = /** @type {((inputs?: Organizationsettings_Emailaddress2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Emailaddress2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_emailaddress2(inputs)
	if (locale === "en") return en_organizationsettings_emailaddress2(inputs)
	return es_organizationsettings_emailaddress2(inputs)
});
export { organizationsettings_emailaddress2 as "organizationSettings_emailAddress" }